<div class="download-app">
  <div class="download-app__container">
    <div class="download-app__links-wrapper">
      <a *ngIf="block.data.googlePlayUrl" class="download-app__link download-app__link--google-play" href="{{block.data.googlePlayUrl}}" target="{{block.data.googlePlayTarget}}">
        <img src="/assets/img/buttons/google-play.png" alt="Get it on Google Play" />
      </a>
      <a *ngIf="block.data.appStoreUrl" class="download-app__link download-app__link--app-store" href="{{block.data.appStoreUrl}}" target="{{block.data.appStoreTarget}}">
        <img src="/assets/img/buttons/app-store.svg" alt="Download on the App Store" />
      </a>
    </div>

    <p *ngIf="block.data.text" class="download-app__text">{{block.data.text}}</p>
  </div>
</div>
